import { isObject } from '../../../../helpers/isObject';

const hasValue = (value) => {
  if ([undefined, null, ''].includes(value)) {
    return false;
  }
  if (Array.isArray(value)) {
    return Boolean(value.length) && value.every(hasValue);
  }
  if (isObject(value)) {
    return Object.values(value).every(hasValue);
  }
  return true;
};

export const normalizeReportParams = (exportParams) => {
  return Object.entries(exportParams).reduce((acc, [fieldName, fieldValue]) => {
    if (fieldName.includes(',') && Array.isArray(fieldValue)) {
      const fNames = fieldName.split(',');
      fieldValue.forEach((value, index) => {
        if (!hasValue(value)) {
          return;
        }
        const fName = fNames[index];
        const fValue = JSON.parse(JSON.stringify(value));
        acc[fName] = fValue;
      });
    } else if (fieldValue !== undefined) {
      acc[fieldName] = JSON.parse(JSON.stringify(fieldValue));
    }
    return acc;
  }, {});
};

export const isReportParamsEmpty = (exportParams) => {
  const normal = normalizeReportParams(exportParams);
  return Object.keys(normal).length === 0;
};
